<template>
  <div class="animated revealUp" style="overflow-x: auto; width: 100%">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("scheduleauditlogs") }}</div>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="getAuditLogs"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div v-if="ScheduleAuditLogs.length > 0">
          Download
          <img
            @click="excelDownload()"
            src="@/assets/img/icons/excel.svg"
            height="25"
            width="25"
            class="mx-1"
          />
        </div>
        <div class="mx-2">
          <b-dropdown variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
          <b-button variant="default" @click="onFetch()" class="btn-blue">{{
            $t("fetch")
          }}</b-button>
        </div>
      </div>
    </div>

    <table class="list-view-table" style="overflow-x: auto; width: 100%">
      <thead>
        <tr>
          <th>
            <img
              v-if="this.columnName != 'user_name'"
              @click="onSortValue('user_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('user_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('user_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("user", 1) }} {{ $t("name") }}
          </th>
          <th>
            <img
              v-if="this.columnName != 'movie_name'"
              @click="onSortValue('movie_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('movie_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('movie_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("movie", 1) }} {{ $t("name") }}
          </th>
          <th style="width: 110px">{{ $t("original") }} {{ $t("time") }}</th>
          <th style="width: 110px">{{ $t("new") }} {{ $t("time") }}</th>
          <th style="width: 110px">{{ $t("typeofaudit") }}</th>
          <th>{{ $tc("details", 2) }}</th>

          <th style="width: 130px">
            <img
              v-if="this.columnName != 'created_at'"
              @click="onSortValue('created_at', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('created_at', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('created_at', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $t("createdat") }}
          </th>
          <th>{{ $t("createdby") }}</th>
        </tr>
      </thead>
      <tbody v-if="ScheduleAuditLogs.length > 0">
        <tr v-for="(item, key) in ScheduleAuditLogs" :key="key">
          <td>{{ item.user_name }}</td>
          <td>{{ item.movie_name }}</td>
          <td>{{ item.original_time }}</td>
          <td>{{ item.new_time }}</td>
          <td>{{ item.type_of_audit }}</td>
          <td>{{ item.audit_details }}</td>
          <td>{{ item.created_at | dateparse }}</td>
          <td>{{ item.created_by }}</td>
        </tr>
      </tbody>
      <tbody v-if="ScheduleAuditLogs.length == 0">
        <tr>
          <td colspan="8">
            <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-if="ScheduleAuditLogs.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemaService from "@/services/CinemasService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      perPageExcel: 100000,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      ScheduleAuditLogs: [],
      ScheduleAuditLogsExcel: [],

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  beforeMount() {
    // this.getAuditLogs();
    this.getviewingnumber();
    // this.getAuditLogsExcel();
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onFetch: function () {
      this.getAuditLogs();
      this.getAuditLogsExcel();
    },
    excelDownload() {
      let temp_data = this.ScheduleAuditLogsExcel;
      // let temp_arr = [];
      // temp_data.map(x => {
      //   x.selectedUsers.map(y => {
      //     let obj = {
      //       ...x,
      //       ...y
      //     };
      //     temp_arr.push(obj);
      //   });
      // });
      // console.log({temp_arr})
      let dateparse = function (value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY")
            : "-";
        //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
        //this is changed acc to mams decision
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY")
            : "-";
      };
      let fulldatemonparse = function (value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY HH:mm")
            : "-";
        //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
        //this is changed acc to mams decision
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY HH:mm")
            : "-";
      };

      let data = [
        {
          sheet: "System Logs",
          columns: [
            {
              value: "user_name",
              label: "User Name",
            },
            {
              value: "movie_name",
              label: "Movie Name",
            },
            {
              value: "original_time",
              label: "Original Time",
            },
            {
              value: (row) => (row.new_time == true ? new_time : "-"),
              label: "New Time",
            },
            {
              value: "type_of_audit ",
              label: "Type of Audit",
            },
            {
              value: "audit_details",
              label: "Audit Details",
            },
            {
              value: (row) => dateparse(row.created_at),
              label: "Created At",
            },
            {
              value: "created_by",
              label: "Created By",
            },
            //      Sold: 0,
            // gross_amount: 0,
            // offer_price: 0,
            // total_taxes: 0,
            // final_gross_amount: 0
          ],
          content: temp_data,
        },
      ];
      let settings = {
        fileName: `ScheduleAuditLog${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getAuditLogs();
      } else {
        this.currentPage = event;
        this.getAuditLogs();
      }
    },
    goToRoute: function (path, item) {
      this.$router.push({
        path: path,
        query: {
          smm_id: item.smm_id,
          signage_type_id: item.signage_type_id,
        },
      });
    },

    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getAuditLogs();
    },
    getAuditLogsExcel() {
      let payload = {
        limit: this.perPageExcel,
        currentPage: 1,
        auditType: "Schedule",
        searchValue: "",
        columnName: "",
        orderBy: "",
      };
      CinemaService.GetAuditLogs(payload)
        .then((response) => {
          const { data } = response;

          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.ScheduleAuditLogsExcel = data.Records;
              this.ScheduleAuditLogsExcel.filter((x) => {
                x.original_time = moment(
                  x.original_time,
                  "YYYY-DD-MM HH:mm:ss"
                ).format("HH:mm");
                x.new_time =
                  x.new_time == null
                    ? null
                    : moment(x.new_time, "YYYY-DD-MM HH:mm:ss").format("HH:mm");
              });

              // this.ScheduleAuditLogs.map((x, index) => {
              //   this.getViewUsersDetails(x.created_by, index, "created_by");
              // });
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });

      xlsx(setting, CinemaService.GetAuditLogs);
    },
    getAuditLogs: function () {
      this.ScheduleAuditLogs = [];
      let loader = this.$loading.show();

      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        auditType: "Schedule",
        columnName: this.columnName,
        orderBy: this.orderby,
        searchValue: this.searchValue,
      };

      CinemaService.GetAuditLogs(payload)
        .then((response) => {
          const { data } = response;

          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.ScheduleAuditLogs = data.Records;
              this.ScheduleAuditLogs.filter((x) => {
                x.original_time = moment(
                  x.original_time,
                  "YYYY-DD-MM HH:mm:ss"
                ).format("HH:mm");
                x.new_time =
                  x.new_time == null
                    ? null
                    : moment(x.new_time, "YYYY-DD-MM HH:mm:ss").format("HH:mm");
              });

              // this.ScheduleAuditLogs.map((x, index) => {
              //   this.getViewUsersDetails(x.created_by, index, "created_by");
              // });

              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    // getViewUsersDetails: function (user_id, index, key) {
    //   console.log("user_id, index, key :>> ", user_id, index, key);
    //   if (user_id) {
    //     MasterService.GetUserInfoById({ user_id })
    //       .then((response) => {
    //         const { data } = response;
    //         if (data && data.status && data.Records.length > 0) {
    //           this.ScheduleAuditLogs[index][key] = data.Records[0].user_name;
    //           console.log(
    //             "this.ScheduleAuditLogs :>> ",
    //             this.ScheduleAuditLogs
    //           );
    //         } else {
    //           this.$toasted.show(data.message);
    //         }
    //       })
    //       .catch(this._CatchError);
    //   }
    // },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ScheduleAuditLogComponents/listgScheduleAuditLogs.vue